module.exports = __webpack_public_path__ + "static/about-us-hero-b56ad40b0ec55521d0ea1c42940b28bd.png";